export function censureEmailContent(email: string | undefined) {
    const arr = (email || '').split('@');
    const name = arr[0];

    return `${name}@...`;
}

export default censureEmailContent;
